import { render, staticRenderFns } from "./TargetsModalProporsal.vue?vue&type=template&id=6b74f946&scoped=true"
import script from "./TargetsModalProporsal.vue?vue&type=script&lang=js"
export * from "./TargetsModalProporsal.vue?vue&type=script&lang=js"
import style0 from "./TargetsModalProporsal.vue?vue&type=style&index=0&id=6b74f946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74f946",
  null
  
)

export default component.exports